import Component from '../component';

export default class BusinessLinesList extends Component {
	constructor(...args) {
		super(...args);

	}


	/*
	init() {
	}
	bind() {
	}
	unbind() {
	}
	resize(width, height) {
	}
	*/
}



// WEBPACK FOOTER //
// ./src/js/components/business-lines-list/business-lines-list.js